import { Fmulinje, FmulinjeKursist } from "../../interfaces/schema";
import { getFields } from "../../util/graphqlUtil";
import { Field } from "../../util/typeUtil";

export const fmulinjeKursistFields = getFields<Field<FmulinjeKursist, 4>>([
  "id",
  "personId",
  "deltagerStatusNavigation.navn",
  "overnatningstypeNavigation.navn",
  "person.id",
  "person.kundeNr",
  "person.fornavne",
  "person.efternavn",
  "person.emailPrivat",
  "person.personart",
  "person.personFirma.emailArbejde",
  "person.personFirma.periode.fraDato",
  "person.personFirma.periode.tilDatoInklusiv",
  "person.personFirma.firma.navn1",
  "person.personFirma.firma.periode.fraDato",
  "person.personFirma.firma.periode.tilDatoInklusiv",
  "person.personPersonart.personartNr",
  "person.personPersonart.periode.fraDato",
  "person.personPersonart.periode.tilDatoInklusiv",
  "person.personPersonart.personartNrNavigation.navn",
  "person.adresse.adresse.landNavigation.navn",
  "person.adresse.adresse.adresselinie1",
  "person.adresse.adresse.postnummer",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
]);

export const fmulinjeFields = getFields<Field<Fmulinje, 2>>([
  "nr",
  "id",
  "navn",
  "hotelId",
  "kursushold.id",
  "kursushold.holdNr",
  "kursushold.navn",
  "kursushold.fmukursusKategoriNavigation.navn",
  "kursushold.fmukursusKategoriNavigation.nr",
  "kursushold.fraDato",
  "kursushold.fraKlDag",
  "kursushold.tilDato",
  "kursushold.tilKlDag",
]);
